var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Card } from '@philips-internal/oswald-ui-components/lib/components';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import SecurityAlertCardAPI from './administration-by-process-card-api';
import { ReactComponent as Repeat } from '../../assets/images/global/repeat.svg';
import './administration-by-process-card.css';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import moment from 'moment';
let AdministrationByProcessCard = class AdministrationByProcessCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { barcode, doseQuantity, endDate, materialDescription, observation, onClick, read, scheduleSequence, throughApplicationStatus } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        barcode,
                        doseQuantity,
                        endDate,
                        materialDescription,
                        observation,
                        onClick,
                        read,
                        scheduleSequence,
                        throughApplicationStatus
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    renderItemTitle(title) {
        return (React.createElement("div", { className: 'c-administration-process-card__description-name' },
            React.createElement("span", { className: 'c-administration-process-card__description-name-text' }, title)));
    }
    renderDefaultItem(textTitle, itemValue, className) {
        return (React.createElement("div", { className: `c-medication-or-solution-details-card__default-infos ${className}` },
            React.createElement("span", { className: 'c-medication-or-solution-details-card__default-title' }, textTitle),
            React.createElement("span", { className: 'c-medication-or-solution-details-card__default-text' }, itemValue && itemValue)));
    }
    renderIndicatorColorStatus() {
        const { endDate, read } = this.props;
        const endDateMoment = moment(String(endDate));
        const currentDate = moment();
        const isEndDateBeforeNow = endDateMoment.isBefore(currentDate);
        return (React.createElement("div", { style: { backgroundColor: isEndDateBeforeNow ? '#FA5D4C' : read ? '#009957' : '#FFCD05' }, className: 'c-administration-process__indicator-color' }));
    }
    renderDescriptionName() {
        const { materialDescription } = this.props;
        return (this.renderItemTitle(materialDescription));
    }
    renderContent() {
        const { doseQuantity, endDate, observation, throughApplicationStatus, unitMeasureCode, unitMeasureDoseCode, quantityDispensed, status, volume } = this.props;
        const dose = unitMeasureDoseCode && `${doseQuantity} ${unitMeasureDoseCode}`;
        const endDateFromatted = moment(String(endDate)).format('L');
        const displayVolume = Number.isInteger(volume);
        const hasContent = this.validateIfHasContent();
        if (!hasContent) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement("div", { className: 'c-administration-process-card__content' },
            React.createElement("div", { className: 'c-medication-or-solution-details-card__content-up' },
                React.createElement("div", { className: 'c-medication-or-solution-details-card__content-up-left' },
                    throughApplicationStatus && (this.renderDefaultItem(MessageService.translate('label.infusion-viewer.application-route'), throughApplicationStatus, '')),
                    quantityDispensed != null && (this.renderDefaultItem(MessageService.translate('text.quantity'), String(quantityDispensed), '')),
                    !displayVolume && unitMeasureCode && (this.renderDefaultItem(MessageService.translate('label.unit-of-measurement'), unitMeasureCode, '')),
                    displayVolume && unitMeasureCode != null && (this.renderDefaultItem(MessageService.translate('txt.volume'), String(volume) + ' ' + unitMeasureCode, '')),
                    endDate && (this.renderDefaultItem(MessageService.translate('txt.due-date'), endDateFromatted, ''))),
                React.createElement("div", { className: 'c-medication-or-solution-details-card__content-up-right' },
                    !quantityDispensed && doseQuantity != null && unitMeasureDoseCode && (this.renderDefaultItem(MessageService.translate('text.dose'), String(dose), 'padding-right')),
                    doseQuantity != null && quantityDispensed != null && (this.renderDefaultItem(MessageService.translate('text.dose'), String(doseQuantity), 'padding-right')),
                    status && (this.renderDefaultItem(MessageService.translate('tws.txt-status'), status, 'padding-right')))),
            React.createElement("div", { className: 'c-medication-or-solution-details-card__content-down' }, observation && (this.renderDefaultItem(MessageService.translate('text.observation'), observation, '')))));
    }
    validateIfHasContent() {
        const { doseQuantity, observation, throughApplicationStatus, unitMeasureCode, unitMeasureDoseCode, quantityDispensed } = this.props;
        return Boolean(doseQuantity
            || observation
            || throughApplicationStatus
            || unitMeasureCode
            || unitMeasureDoseCode
            || quantityDispensed);
    }
    renderResetButton() {
        const { read } = this.props;
        return (React.createElement(React.Fragment, null, read && (React.createElement("div", { className: 'c-administration-process-card__reset-button' },
            React.createElement("div", { className: 'c-administration-process-card__reset-container', onClick: () => this.handleClick() },
                React.createElement(Repeat, null),
                React.createElement("span", { className: 'c-administration-process-card__reset-button-text' }, MessageService.translate('text.undo')))))));
    }
    renderField() {
        const { read } = this.props;
        return (React.createElement("div", { className: 'c-administration-process-card__container', style: { opacity: !read ? '0.5' : '1' } },
            React.createElement("div", { className: 'c-administration-process-card__container-status' },
                this.renderIndicatorColorStatus(),
                this.renderDescriptionName(),
                this.renderContent()),
            this.renderResetButton()));
    }
    render() {
        const { scheduleSequence } = this.props;
        const legends = [
            {
                color: 'signal-green-60',
                label: MessageService.translate('tws.read-items'),
                value: MessageService.translate('tws.read-items')
            },
            {
                color: 'signal-yellow-45',
                label: MessageService.translate('tws.unread-items'),
                value: MessageService.translate('tws.unread-items')
            },
            {
                color: 'signal-red-45',
                label: MessageService.translate('tws.expired-items'),
                value: MessageService.translate('tws.expired-items')
            },
        ];
        return (React.createElement(Card, { className: 'c-administration-process-card', selectionType: SelectionType.SINGLE, superscription: legends, uuid: generateUUID(), width: 12, key: scheduleSequence }, this.renderField()));
    }
};
AdministrationByProcessCard = __decorate([
    AwesomeComponent({ api: SecurityAlertCardAPI, type: ComponentType.DATA_DISPLAY })
], AdministrationByProcessCard);
export default AdministrationByProcessCard;
//# sourceMappingURL=administration-by-process-card.js.map